import { varKey, varLabel } from "common/var";
import {
  Col,
  message,
  Modal,
  Progress,
  Row,
  Select,
  Spin,
} from "components/common";
import { useEffect, useState } from "react";
import { callGetApiWithAuth } from "utils/api";
import { asPercent, asVolume } from "utils/text";
import { Wrapper } from "../../../home/rank/RankCard.styled";

export default function BuilderRankWidgetModal(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [statData, setStatData] = useState({
    rank: { name: "Unranked" },
    next_rank: { name: "Director" },
    mp: 0,
    ap: 0,
    qop: 0,
    next_mp: 0,
    next_ap: 0,
    next_qop: 0,
    mp_percent: 0,
    ap_percent: 0,
    qop_percent: 0,
    c_cnt: 0,
    tl_cnt: 0,
    stl_cnt: 0,
    leg_chart: 0,
    has_qop_chart: false,
    is_commission_qualified: false,
  });
  const [viewMode, setViewMode] = useState("current");
  const [nextRanks, setNextRanks] = useState([]);
  const [selectedNextRankIndex, setSelectedNextRankIndex] = useState(0);

  const onGetStatData = (res) => {
    setIsLoaded(true);
    if (!res.success) {
      return message.error(res.message);
    }
    
    // Handle new API response with array of ranks
    if (Array.isArray(res.data) && res.data.length > 0) {
      setNextRanks(res.data);
      // Set initial data to first next rank
      const firstNextRank = res.data[0];
      setStatData(firstNextRank);
      setSelectedNextRankIndex(0);
    } else {
      // Fallback to old API structure
      setStatData(res.data);
      setNextRanks([]);
    }
  };
  const onFailStatData = () => {
    setIsLoaded(true);
  };

  const handleNextRankChange = (index) => {
    setSelectedNextRankIndex(index);
    if (nextRanks[index]) {
      setStatData(nextRanks[index]);
    }
  };

  useEffect(() => {
    setIsLoaded(false);
    if (viewMode == "current") {
      callGetApiWithAuth(
        `rank_tracker/builder_rank/rank_stats_all/${props.userId}`,
        onGetStatData,
        onFailStatData
      );
    } else if (viewMode == "last") {
      callGetApiWithAuth(
        `rank_tracker/builder_rank/last_rank_stats/${props.userId}`,
        onGetStatData,
        onFailStatData
      );
    }
  }, [viewMode]);

  return (
    <Modal onCancel={props.onCancel} width={800}>
      <Wrapper style={{ border: "none", padding: "24px" }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="card-title">Builder Rank</div>
          <Select
            value={viewMode}
            onChange={(v) => setViewMode(v)}
            options={[
              {
                label: "Current Month",
                value: "current",
              },
              {
                label: "Last Month",
                value: "last",
              },
            ]}
            style={{ width: "160px" }}
          />
        </div>

        {isLoaded ? (
          <Row className="align-items-center" gutter={[24, 24]}>
            <Col xs={24} className="responsive-rank">
              <div className="liquid-container">
                <Progress
                  type="circle"
                  percent={statData.total_percent * 100}
                  strokeWidth={9}
                  size="large"
                  format={(percent) => {
                    return asPercent(percent / 100);
                  }}
                  strokeColor={{
                    "0%": "#7FCFF4",
                    "25%": "#0ABAB5",
                    "50%": "#0ABAB5",
                    "75%": "#0ABAB5",
                    "100%": "#7FCFF4",
                  }}
                />
              </div>
            </Col>
            <Col xs={24}>
              <Row gutter={[24, 24]}>
                <Col span={12}>
                  <div className="rank-box" style={{ display: 'flex', alignItems: 'center', minHeight: '100%' }}>
                    <div style={{ width: '100%' }}>
                      <div className="rank-para">Current Rank</div>
                      <div className="rank-head">{statData.rank.name}</div>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="rank-box">
                    <div style={{ width: '100%' }}>
                      <div className="rank-para">
                        {nextRanks.length > 1 ? 'Target Rank' : 'Next Rank'}
                      </div>
                      <div className="rank-head">
                        {statData.next_rank?.name || 'Unranked'}
                      </div>
                      {nextRanks.length > 1 && (
                        <div style={{ marginTop: '12px', position: 'relative', height: '32px', width: '100%' }}>
                          <button 
                            onClick={() => handleNextRankChange(Math.max(0, selectedNextRankIndex - 1))}
                            disabled={selectedNextRankIndex === 0}
                            style={{
                              position: 'absolute',
                              left: '0',
                              width: '32px',
                              height: '32px',
                              padding: '0',
                              cursor: selectedNextRankIndex === 0 ? 'not-allowed' : 'pointer',
                              opacity: selectedNextRankIndex === 0 ? 0.5 : 1,
                              border: '1px solid #d9d9d9',
                              borderRadius: '50%',
                              background: '#fff',
                              fontSize: '16px',
                              transition: 'all 0.3s',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            {'<'}
                          </button>
                          <div style={{ 
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            fontSize: '12px',
                            color: '#666'
                          }}>
                            {selectedNextRankIndex + 1} / {nextRanks.length}
                          </div>
                          <button 
                            onClick={() => handleNextRankChange(Math.min(nextRanks.length - 1, selectedNextRankIndex + 1))}
                            disabled={selectedNextRankIndex === nextRanks.length - 1}
                            style={{
                              position: 'absolute',
                              right: '0',
                              width: '32px',
                              height: '32px',
                              padding: '0',
                              cursor: selectedNextRankIndex === nextRanks.length - 1 ? 'not-allowed' : 'pointer',
                              opacity: selectedNextRankIndex === nextRanks.length - 1 ? 0.5 : 1,
                              border: '1px solid #d9d9d9',
                              borderRadius: '50%',
                              background: '#fff',
                              fontSize: '16px',
                              transition: 'all 0.3s',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            {'>'}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs={24}>
              <div>
                <Row gutter={[24, 4]}>
                  {statData.has_qop_chart && (
                    <Col span={24}>
                      <div className="line-progress-container">
                        <div className="line-progress-box">
                          <div className="line-progress-title">
                          Organization Points With Capped Max Leg
                          </div>
                          <div className="line-progress-value">
                            ({asVolume(statData.qop)}/
                            {asVolume(statData.next_qop)})
                          </div>
                        </div>
                        <Progress
                          percent={100 * statData.qop_percent}
                          size="small"
                          strokeWidth={4}
                          strokeColor="#FFAB00"
                          showInfo={false}
                        />
                      </div>
                    </Col>
                  )}

                  {statData.has_qop_chart && (
                    <Col span={24}>
                      <div className="line-progress-container">
                        <div className="line-progress-box">
                          <div className="line-progress-title">
                            Total Organization Points
                          </div>
                          <div className="line-progress-value">
                            ({asVolume(statData.op)}/
                            {asVolume(statData.next_qop)})
                          </div>
                        </div>
                        <Progress
                          percent={100 * (statData.op / statData.next_qop)}
                          size="small"
                          strokeWidth={4}
                          strokeColor="#FFAB00"
                          showInfo={false}
                        />
                      </div>
                    </Col>
                  )}

                  {statData.leg_chart > 0 && (
                    <Col span={24}>
                      <div className="line-progress-container">
                        <div className="line-progress-box">
                          <div className="line-progress-title">
                            {varLabel("rank.leg_chart", statData.leg_chart)}{" "}
                            LEGS
                          </div>
                          <div className="line-progress-value">
                            (
                            {asVolume(
                              statData[
                                varKey("rank.leg_chart", statData.leg_chart)
                              ]
                            )}
                            /
                            {asVolume(
                              statData[
                                "next_" +
                                  varKey("rank.leg_chart", statData.leg_chart)
                              ]
                            )}
                            )
                          </div>
                        </div>
                        <Progress
                          percent={
                            100 *
                            statData[
                              varKey("rank.leg_chart", statData.leg_chart) +
                                "_percent"
                            ]
                          }
                          size="small"
                          strokeWidth={4}
                          strokeColor="#FFAB00"
                          showInfo={false}
                        />
                      </div>
                    </Col>
                  )}

                  {statData.ple_leg_chart > 0 && (
                    <Col span={24}>
                      <div className="line-progress-container">
                        <div className="line-progress-box">
                          <div className="line-progress-title">
                            Personal Enrollment{" "}
                            {varLabel(
                              "rank.ple_leg_chart",
                              statData.ple_leg_chart
                            )}{" "}
                            LEGS
                          </div>
                          <div className="line-progress-value">
                            (
                            {asVolume(
                              statData[
                                varKey(
                                  "rank.ple_leg_chart",
                                  statData.ple_leg_chart
                                )
                              ]
                            )}
                            /
                            {asVolume(
                              statData[
                                "next_" +
                                  varKey(
                                    "rank.ple_leg_chart",
                                    statData.ple_leg_chart
                                  )
                              ]
                            )}
                            )
                          </div>
                        </div>
                        <Progress
                          percent={
                            100 *
                            statData[
                              varKey(
                                "rank.ple_leg_chart",
                                statData.ple_leg_chart
                              ) + "_percent"
                            ]
                          }
                          size="small"
                          strokeWidth={4}
                          strokeColor="#FFAB00"
                          showInfo={false}
                        />
                      </div>
                    </Col>
                  )}
                  <Col span={24}>
                    <div className="line-progress-container">
                      <div className="line-progress-box">
                        <div className="line-progress-title">
                          Commission Qualified
                        </div>
                        <div className="line-progress-value">
                          {statData.is_commission_qualified ? (
                            <>
                              <span style={{ color: "green" }}>✅</span> Yes
                            </>
                          ) : (
                            <>
                              <span style={{ color: "red" }}>❌</span>No
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        ) : (
          <div style={{ height: 300 }}>
            <Spin spinning={true} className="loading-icon" />
          </div>
        )}
      </Wrapper>
    </Modal>
  );
}
